var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShopUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "shop_user_bg",
    transform: "translate(-153 -465)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1435",
    "data-name": "Rectangle 1435",
    width: 69,
    height: 69,
    rx: 34.5,
    transform: "translate(153 465)",
    fill: "#fc4b77"
  }), /*#__PURE__*/React.createElement("g", {
    id: "shop_user",
    transform: "translate(-4.223 25.386)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1445",
    "data-name": "Rectangle 1445",
    width: 48,
    height: 48,
    transform: "translate(168.223 450.614)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "shop",
    d: "M4.9,1.578A1.651,1.651,0,0,1,6.159,1h14.1a1.651,1.651,0,0,1,1.255.578L25.822,6.6a2.477,2.477,0,0,1,.6,1.611v.421A3.921,3.921,0,0,1,19.4,11.044a3.922,3.922,0,0,1-6.192,0,3.922,3.922,0,0,1-6.192,0A3.921,3.921,0,0,1,0,8.636V8.215A2.477,2.477,0,0,1,.6,6.6L4.905,1.576ZM7.843,8.636a2.27,2.27,0,1,0,4.541,0,.826.826,0,0,1,1.651,0,2.27,2.27,0,1,0,4.541,0,.826.826,0,0,1,1.651,0,2.27,2.27,0,1,0,4.541,0V8.215a.826.826,0,0,0-.2-.537L20.259,2.651H6.159L1.849,7.679a.826.826,0,0,0-.2.537v.421a2.27,2.27,0,1,0,4.541,0,.826.826,0,0,1,1.651,0ZM2.477,13.383a.826.826,0,0,1,.826.826v9.907H4.953V15.86A1.651,1.651,0,0,1,6.6,14.209h4.953a1.651,1.651,0,0,1,1.651,1.651v8.256h9.907V14.209a.826.826,0,0,1,1.651,0v9.907h.826a.826.826,0,1,1,0,1.651H.826a.826.826,0,1,1,0-1.651h.826V14.209A.826.826,0,0,1,2.477,13.383ZM6.6,24.116h4.953V15.86H6.6ZM14.86,15.86a1.651,1.651,0,0,1,1.651-1.651h3.3a1.651,1.651,0,0,1,1.651,1.651v4.953a1.651,1.651,0,0,1-1.651,1.651h-3.3a1.651,1.651,0,0,1-1.651-1.651Zm4.953,0h-3.3v4.953h3.3Z",
    transform: "translate(168.305 455.787)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-user",
    "data-name": "Icon feather-user",
    transform: "translate(194.723 471.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M25.839,28.652a.786.786,0,0,1-.786-.786v-.378a4.169,4.169,0,0,0-4.164-4.164h-9.9a4.164,4.164,0,0,0-4.164,4.164v.378a.786.786,0,0,1-1.573,0v-.378a5.737,5.737,0,0,1,5.737-5.737h9.9a5.743,5.743,0,0,1,5.737,5.737v.378A.786.786,0,0,1,25.839,28.652Z",
    transform: "translate(-5.25 -7.947)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M16.987,3.75h0A5.737,5.737,0,1,1,11.25,9.487,5.743,5.743,0,0,1,16.987,3.75Zm0,9.9a4.164,4.164,0,1,0,0-8.328h0a4.164,4.164,0,1,0,0,8.328Z",
    transform: "translate(-6.299 -3.75)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopUser);
export default __webpack_public_path__ + "static/media/shop_user.8070bd1a435af6e064873e20fe1e5f23.svg";
export { ForwardRef as ReactComponent };